module.exports = __webpack_public_path__ + "static/img/1-1Z60316291A29.452c0e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z60316291A29.jpg
// module id = QW0B
// module chunks = 0